<template>
  <b-row>
    <b-col xs="12" lg="12">
      <b-card>
        <div slot="header">
          <strong>Administración - General</strong>
        </div>
        <b-tabs v-model="tabIndex">
          <div >
            <b-tab title="Roles/Permisos">
                <RolesPermissions></RolesPermissions>
            </b-tab>
            <b-tab title="Parametros">
                <Controles></Controles>
            </b-tab>
            <b-tab class="p-0" title="Guías de respuestas a emergencias" @click="onHandleShowCustomFields()">
                <NuGreComponent></NuGreComponent>
            </b-tab>

            <!-- Unificación de componentes -->
            <b-tab class="p-0" @click="onHandleShowUnifyComponents">
              <template #title>
                Unificación de componentes <b-badge variant='warning'>Nuevo</b-badge>
              </template>
              <UnifyComponentes />
            </b-tab>

            <!-- Países - Soluquim con empresas multinacionales -->
            <b-tab class="p-0" @click="onHandleShowCountriesSettings">
              <template #title>
                Países <b-badge variant='primary'><i class="fa fa-star"></i> Nuevo</b-badge>
              </template>
              <AdministrationCountriesIndex />
            </b-tab>

          </div>
        </b-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import loader from "../../containers/loader";
import RolesPermisos from './RolesPermisos'
import Controles from './Controles'
import RolesPermissions from './roles_permissions';
import NuGreComponent from './NuGres/Index.vue'
import UnifyComponentes from '../productos/cas/nuevoCas/unifyComponents/Index.vue'
import AdministrationCountriesIndex from './Countries/Index.vue'

export default {
  name: "administracion",
  components: {
    RolesPermisos,
    Controles,
    loader,
    RolesPermissions,
    NuGreComponent,
    UnifyComponentes,
    AdministrationCountriesIndex
  },
  data() {
    return {
      tabIndex: 0,
    };
  },
  async created() {
  },
  watch: {
    tabIndex(newValue) {
      switch (newValue) {
        case 0:

          break;
        case 1:
          this.traeRolesPermisos();
          break;
        case 2:
          this.controles();
          break;
        default:
        break;
      }
    }
  },
  computed: {
     ...mapState("administracion", [
            "filtroControles"
        ]),

  },

  methods: {

    ...mapMutations("administracion", [
      "resetFiltroControles"
    ]),

    ...mapMutations("dashboard", ["load"]),
    ...mapActions("administracion", [
        "getRoles",
        "getPermisos",
        "getPermisosFiltro",
        "getPermisosPorRol",
        "getControles"
    ]),

    // Métodos para el modulo del Naciones unidas - gre
    ...mapActions('NuGreCustomFields', {
      getAllCustomFields: 'getAll'
    }),

    ...mapActions('unifyComponents', {
      getAllUnifyComponents: 'getAll'
    }),

    // Acciones para el modulo del configuración de países
    ...mapActions("AdministrationCountries", {
        getAllCountrySettings: 'getAll'
    }),

    async traeRolesPermisos() {
        this.load(true);
        await this.getRoles();
        await this.getPermisosPorRol();
        await this.getPermisosFiltro();
        this.load(false);
    },

    async controles(){
        this.resetFiltroControles();
        await this.getControles();
    },

    /**
     * CLic en el tab de naciones unidas Gre.
     * @author Fernando Claros
     */
    async onHandleShowCustomFields() {
      await this.getAllCustomFields();
    },

    async onHandleShowUnifyComponents() {
      await this.getAllUnifyComponents({ page: 1, per_page: 10 });
    },

    async onHandleShowCountriesSettings() {
      await this.getAllCountrySettings({ page: 1, per_page: 10 });
    },

  }
};
</script>
